export const NavLinks = [
  {
    id: 1,
    Name: "Home",
    route: "/",
  },
  {
    id: 2,
    Name: "Services",
    route: "/services",
    children: [
      {
        id: 23,
        Name: "Fit out & Renovations",
        route: "/fit-out-services",
        children: [
          {
            id: 41,
            Name: "Kitchen Renovation",
            route: "/fit-out-services/kitchen-renovation",
          },
          {
            id: 42,
            Name: "Bathroom Renovation",
            route: "/fit-out-services/bathroom-renovation",
          },
          {
            id: 43,
            Name: "Painting Flooring",
            route: "/fit-out-services/painting-flooring",
          },
          {
            id: 44,
            Name: "Wardrobe & Cabinets",
            route: "/fit-out-services/wardrobe-&-cabinets",
          },
          {
            id: 45,
            Name: "Villa Renovations",
            route: "/fit-out-services/villa-renovations",
          },
          {
            id: 46,
            Name: "Office Renovation",
            route: "/fit-out-services/office-renovation",
          },
          {
            id: 47,
            Name: "Villa Extensions & Doors",
            route: "/fit-out-services/villa-extensions-&-doors",
          },
          {
            id: 48,
            Name: "Landscaping",
            route: "/fit-out-services/landscaping",
          },
          {
            id: 49,
            Name: "Interior Renovation",
            route: "/fit-out-services/interior-renovation",
          },
          {
            id: 50,
            Name: "Exterior Revamp",
            route: "/fit-out-services/exterior-revamp",
          },
          {
            id: 51,
            Name: "Lightning Installation",
            route: "/fit-out-services/lightning-installation",
          },
        ],
      },
      {
        id: 25,
        Name: "RPH Investment Support",
        route: "/investment-support",
      },

      {
        id: 24,
        Name: "Maintenance",
        route: "/maintenance-company",
        children: [
          {
            id: 31,
            Name: "Villa Maintenance",
            route: "/maintenance-company/villa-maintenance",
          },
          {
            id: 32,
            Name: "Appartment Maintenance",
            route: "/maintenance-company/appartment-maintenance",
          },
          {
            id: 33,
            Name: "Swimming Pool",
            route: "/maintenance-company/swimming-pool",
          },
          {
            id: 34,
            Name: "AC Installation",
            route: "/maintenance-company/ac-installation",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    Name: "About",
    route: "/about",
  },
  {
    id: 4,
    Name: "Portfolio",
    route: "/portfolio",
  },
  { id: 5, Name: "Blog", route: "/blogs" },
  {
    id: 6,
    Name: "Contact",
    route: "/contact",
  },
  {
    id: 7,
    Name: "FAQ",
    route: "/faq",
  },
];
